"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SwimmingPool;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SwimmingPool(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Facilities"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "swimming-pool"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "74.033",
    cy: "35.814",
    r: "7.96",
    transform: "translate(-3.641 62.839) rotate(-45)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M90,72.646c-3.167,0-4.639-1.1-6.5-2.5a14.647,14.647,0,0,0-19,0c-1.863,1.4-3.334,2.5-6.5,2.5s-4.639-1.1-6.5-2.5a14.643,14.643,0,0,0-19,0c-1.862,1.4-3.333,2.5-6.5,2.5s-4.635-1.1-6.5-2.5a14.288,14.288,0,0,0-9.5-3.5,2.5,2.5,0,0,0,0,5c3.165,0,4.635,1.1,6.5,2.5a14.639,14.639,0,0,0,19,0c1.862-1.4,3.334-2.5,6.5-2.5s4.638,1.1,6.5,2.5a14.646,14.646,0,0,0,19,0c1.862-1.4,3.334-2.5,6.5-2.5s4.639,1.1,6.5,2.5a14.3,14.3,0,0,0,9.5,3.5,2.5,2.5,0,0,0,0-5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10,59.285c3.165,0,4.635,1.1,6.5,2.5a14.283,14.283,0,0,0,9.5,3.5,14.289,14.289,0,0,0,9.5-3.5c1.862-1.4,3.334-2.5,6.5-2.5s4.638,1.1,6.5,2.5a14.646,14.646,0,0,0,19,0c1.862-1.4,3.334-2.5,6.5-2.5s4.639,1.1,6.5,2.5a14.292,14.292,0,0,0,9.5,3.5,2.5,2.5,0,0,0,0-5c-3.167,0-4.639-1.1-6.5-2.5a14.647,14.647,0,0,0-19,0c-1.863,1.4-3.334,2.5-6.5,2.5s-4.639-1.1-6.5-2.5a23.027,23.027,0,0,0-2.743-1.842l15.72-9.1a2.5,2.5,0,0,0,.716-3.7l-9.958-12.7a2.494,2.494,0,0,0-2.552-.889L34.136,34.007a2.5,2.5,0,0,0,1.17,4.861l16.979-4.087,7.192,9.175L42.4,53.846a2.43,2.43,0,0,0-.55.447,14.321,14.321,0,0,0-9.352,3.492c-1.862,1.4-3.333,2.5-6.5,2.5s-4.635-1.1-6.5-2.5a14.293,14.293,0,0,0-9.5-3.5,2.5,2.5,0,0,0,0,5Z"
  })))));
}